import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import BaseSpinWrapper from 'components/atoms/base-spin-wrapper';
import { useGetSmsSummaryMetrics } from 'infrastructure/hooks/sms-metrics/use-get-sms-summary-metrics';
import colors from 'assets/styles/colors';

import SmsMetricsPieChart from '../pie-chart';

import type { ISmsMetricsFilters } from 'infrastructure/interfaces';

interface IProps {
  filter: ISmsMetricsFilters;
}

const colorMap: Record<string, string> = {
  user: colors.green50,
  incoming: colors.orange50,
  null: colors.orange50,
  'adherence-automated': colors.purple50,
  'automated-response': colors.blue50,
  unknown: colors.red50,
  campaign: colors.yellow50,
};

const SmsTypeOverviewPieChart: React.FC<IProps> = (props) => {
  const { filter } = props;

  const { t } = useTranslation();

  const { data, isLoading } = useGetSmsSummaryMetrics(filter, 'type');

  const mappedData = useMemo(() => {
    const temp: Record<string, { value: number; name: string; color: string }> =
      {};

    data.forEach((el) => {
      const name = t(`smsTypes.${el.smsType}` as any);
      const color = colorMap[el.smsType];

      if (temp[name]) {
        temp[name].value += el.count;
      } else {
        temp[name] = { value: el.count, name, color };
      }
    });

    return Object.values(temp);
  }, [data, isLoading]);

  return (
    <BaseSpinWrapper spinning={isLoading}>
      <SmsMetricsPieChart
        title={t('labels.smsTypeOverview')}
        data={mappedData}
      />
    </BaseSpinWrapper>
  );
};

export default SmsTypeOverviewPieChart;
